import React from 'react';

import { css } from '@emotion/core';
import isPropValid from '@emotion/is-prop-valid';
import styled from '@emotion/styled';
import { color } from '@styles/themes';
import { Col as ACol, ColProps } from 'antd';
import { tuple } from 'antd/lib/_util/type';

export const tYzTypeCol = tuple(
  'include-pagination',
  'sign-in',
  'filter',
  'verticalDivider',
  'header-logo',
  'center',
  'survey-guide',
  'footer-prev-button-col',
  'footer-next-button-col',
  'selected-onset-button',
  'onset-button',
  'selected-check-button',
  'check-button',
);

type TYzTypeCol = (typeof tYzTypeCol)[number] | undefined;

export interface IColParmas extends ColProps {
  yzTypeCol?: TYzTypeCol;
  twoColumnsInRowFlag?: boolean;
  oneColumnInRowFlag?: boolean;
}

const handleColStyleWithType = ({ yzTypeCol }: IColParmas) => {
  switch (yzTypeCol) {
    case 'selected-onset-button':
      return css`
        width: 100%;
        text-align: center;
        height: 50px;
        background: #d4e8ff;
        color: ${color.infoText};
        border: 1px solid #c2d5eb;
        border-radius: 12px;

        font-size: 15px;
        line-height: 50px;
        letter-spacing: 0.01em;
        font-weight: 400;

        :hover {
          cursor: pointer;
        }

        :active,
        :focus,
        :hover {
          color: ${color.infoText};
          border: 1px solid #c2d5eb;
        }
      `;
    case 'onset-button':
      return css`
        width: 100%;
        text-align: center;
        height: 50px;
        background: ${color.white};
        color: ${color.infoText};
        border: 1px solid #e5e5e5;
        border-radius: 12px;

        font-size: 15px;
        line-height: 50px;
        letter-spacing: 0.01em;
        font-weight: 400;

        :hover {
          cursor: pointer;
        }

        :active,
        :focus,
        :hover {
          background: ${color.white};
          color: ${color.infoText};
          border: 1px solid #e5e5e5;
        }
      `;
    case 'selected-check-button':
      return css`
        width: 100%;
        word-break: keep-all;
        /* text-align: left; */
        /* text-indent: 20px; */
        height: 52px;
        background: #d4e8ff;
        color: ${color.infoText};
        border: 1px solid #c2d5eb;
        border-radius: 12px;

        font-size: 15px;
        /* line-height: 52px; */
        letter-spacing: 0.01em;
        font-weight: 400;

        :hover {
          cursor: pointer;
        }

        :active,
        :focus,
        :hover {
          color: ${color.infoText};
          border: 1px solid #c2d5eb !important;
        }
      `;
    case 'check-button':
      return css`
        width: 100%;
        word-break: keep-all;
        /* text-align: left; */
        /* text-indent: 20px; */
        height: 52px;
        background: ${color.white};
        color: ${color.infoText};
        border: 1px solid #e5e5e5;
        border-radius: 12px;

        font-size: 15px;
        /* line-height: 52px; */
        letter-spacing: 0.01em;
        font-weight: 400;

        :hover {
          cursor: pointer;
        }

        :active,
        :focus,
        :hover {
          background: ${color.white};
          color: ${color.infoText};
          border: 1px solid #e5e5e5;
        }
      `;
    case 'header-logo':
      return css`
        height: 100%;
        line-height: normal;
        padding-top: 22px;
      `;
    case 'center':
      return css`
        margin: 0 auto;
      `;
    case 'footer-prev-button-col':
      return css`
        width: 50%;
        padding-left: 0;
        border-color: #e5e5e5 !important;

        :active,
        :focus,
        :hover {
          border-color: #e5e5e5 !important;
        }
      `;
    case 'footer-next-button-col':
      return css`
        width: 50%;
        padding-right: 0;
      `;
    case 'survey-guide':
      return css`
        padding: 15px;
        width: 100%;
        background: #f5f5f5;
        border-radius: 12px;
      `;
    case 'sign-in':
      return css`
        padding-top: 91px;
        padding-bottom: 80px;
      `;
    case 'filter':
      return css``;
    case 'verticalDivider':
      return css`
        border-right: solid 1px #d9dde1;
      `;
    default:
      return css``;
  }
};

const handleColStyleWithFlag = ({ twoColumnsInRowFlag, oneColumnInRowFlag }: IColParmas) => {
  if (twoColumnsInRowFlag) {
    return css`
      :nth-child(odd) {
        margin-left: -2.5px;
        margin-right: 2.5px;
      }

      :nth-child(even) {
        margin-right: -2.5px;
        margin-left: 2.5px;
      }
    `;
  }
  if (oneColumnInRowFlag) {
    return css`
      margin-right: -2.5px;
      margin-left: -2.5px;
    `;
  }
  return css``;
};

const StyledCol = styled(ACol, { shouldForwardProp: isPropValid })<IColParmas>`
  ${({ yzTypeCol }) => handleColStyleWithType({ yzTypeCol })}
  ${({ twoColumnsInRowFlag, oneColumnInRowFlag }) =>
    handleColStyleWithFlag({ twoColumnsInRowFlag, oneColumnInRowFlag })}
`;

export const Col = ({ children, ...rest }: IColParmas) => <StyledCol {...rest}>{children}</StyledCol>;
